import React, { FC } from 'react'

import { NoItemsProps } from './NoItems.props'

import './NoItems.scss'

const NoItems: FC<NoItemsProps> = ({ name }) => (
  <div className="noitems-container">
    <div className="noitems">
      <div className="noitems__title">{`0 of 0 ${name}`}</div>
      <div className="noitems__body">Try another selection of fliters.</div>
    </div>
  </div>
)

export default NoItems
